export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";

export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";

export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";

export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";

export const USER_REGISTER_FAILURE = "USER_REGISTER_FAILURE";
